// AppLoaderLayer.tsx
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { AppLoaderLayerContainer, AppLoaderLayerOverlay } from './app-loader-layer.styles';
import { LoaderIcon } from '@keplerco/core';
import { useLoading } from '../../../../global-state';

export function AppLoaderLayer(): JSX.Element {

  const isLoading = useLoading();

  const [show, setShow] = useState<boolean>(false);
  const [syncing, setSyncing] = useState<boolean>(false);

  const time = useRef<NodeJS.Timeout | undefined>(undefined);
  const [forceUpdate, setForceUpdate] = useState<number>(0);

  useEffect(() => {
    time.current = setTimeout(() => {
      time.current = undefined;
      setForceUpdate(latest => latest + 1);
    }, 100);
  }, [isLoading]);

  useEffect(() => {
    setShow(isLoading);
  }, [time, forceUpdate]);

  useEffect(() => {
    window.document.body.classList.toggle('appLoaderOpen', show);
  }, [show]);

  return ReactDOM.createPortal(
    <AppLoaderLayerOverlay open={show}>
      <AppLoaderLayerContainer>
        <LoaderIcon size={65} />

        <p className="body1">{syncing ? `Syncing...` : `Loading...`}</p>
      </AppLoaderLayerContainer>
    </AppLoaderLayerOverlay>,
    window.document.body
  );
}
